module.exports = __webpack_public_path__ + "img/chofu_cycle_off.dea60ddc.svg";